<template lang="pug">
  .slide(:style="slideStyles")
    slot
</template>

<script>
  export default {
    name: 'Slide',
    inject: ['data'],
    props: {
      index: Number,
      isClone: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        active: false,
      };
    },
    computed: {
      slideStyles() {
        return {
          width: `${this.data.slideWidth}px`,
        };
      },
    },
  };
</script>

<style scoped lang="scss">
  .slide {
    display: flex;
    flex-direction: column;
    margin: 0 $spacing-unit * 5 0 0;

    @include tablet-up {
      margin: 0 $spacing-unit * 10 0 0;
    }

    .product-media-gallery & {
      padding: 0;
    }
  }

  .slide--follow-us {
    padding: 0 $spacing-unit * 3;
  }

  .slide--value-props {
    display: block;
    padding: 0 $spacing-unit * 3;
  }

  .slide--featured-collections {
    padding: 0 $spacing-unit * 4 0 0;
  }

  .slide--product-ingredients,
  .slide--meet-our-healers {
    padding: 0 $spacing-unit 0 0;
  }
</style>
